document.addEventListener('DOMContentLoaded', function() {
  initColorSwatchImageChange();
});

function initColorSwatchImageChange() {
  document.querySelectorAll('[data-event="change_image"]').forEach(swatch => {
    let originalImage = null;
    
    swatch.addEventListener('mouseenter', function(e) {
      e.preventDefault();
      
      const productCard = this.closest('.product-card');
      if (!productCard) return;
      

      if (!originalImage) {
        const mainImage = productCard.querySelector('.product-card__media a.media img');
        if (mainImage) {
          originalImage = {
            src: mainImage.src,
            srcset: mainImage.srcset,
            alt: mainImage.alt
          };
        }
      }
      
      const variantUrl = this.getAttribute('href');
      const variantId = extractVariantIdFromUrl(variantUrl);
      
      const mediaContainer = productCard.querySelector('.product-card__media a.media');
      if (!mediaContainer) return;
      
      changeProductImage(productCard, variantId, variantUrl);
      updateSwatchSelection(productCard, this);
    });
    

    swatch.addEventListener('mouseleave', function(e) {
      const productCard = this.closest('.product-card');
      if (!productCard || !originalImage) return;
      
      const mainImage = productCard.querySelector('.product-card__media a.media img');
      if (!mainImage) return;

      mainImage.style.opacity = '0';
      
      setTimeout(() => {
        mainImage.src = originalImage.src;
        mainImage.srcset = originalImage.srcset;
        mainImage.alt = originalImage.alt;
        
        mainImage.style.transition = 'opacity 0.3s ease';
        mainImage.style.opacity = '1';
      }, 50);
      
      updateSwatchSelection(productCard, null);
    });
  });
}

function extractVariantIdFromUrl(url) {
  const match = url.match(/[?&]variant=(\d+)/);
  return match ? match[1] : null;
}

function changeProductImage(productCard, variantId, variantUrl) {
  const baseUrl = variantUrl.split('?')[0];
  const productUrl = baseUrl + '.js';
  
  fetch(productUrl)
    .then(response => response.json())
    .then(product => {
      const variant = product.variants.find(v => v.id == variantId);
      
      if (variant && variant.featured_image) {
        updateMainImage(productCard, variant.featured_image);
      }
    })
    .catch(error => {
      console.error('Error fetching product data:', error);
    });
}

function updateMainImage(productCard, imageData) {
  const mediaContainer = productCard.querySelector('.product-card__media a.media');
  const mainImage = mediaContainer.querySelector('img');
  
  if (!mainImage) return;

  const newImageUrl = imageData.src;

  const widths = [180, 360, 540, 720, 900, 1080];
  const srcset = widths.map(width => {
    const resizedUrl = newImageUrl.replace(/\.jpg|\.png|\.webp/, `_${width}x$&`);
    return `${resizedUrl} ${width}w`;
  }).join(', ');
  
  mainImage.style.opacity = '0';
  
  setTimeout(() => {
    mainImage.src = newImageUrl;
    mainImage.srcset = srcset;
    mainImage.alt = imageData.alt || '';
    
    mainImage.style.transition = 'opacity 0.3s ease';
    mainImage.style.opacity = '1';
  }, 50);
}

function updateSwatchSelection(productCard, selectedSwatch) {
  const allSwatches = productCard.querySelectorAll('.color-swatch');
  allSwatches.forEach(swatch => {
    swatch.classList.remove('active', 'selected');
  });

  if (selectedSwatch) {
    selectedSwatch.classList.add('active', 'selected');
  }
}